/**
 * Created by Marcus Zhao
 * Description: setting contact template layout
 * ------ maintenance history ------
 * Updated by Daniel Wang on 12/22/2022, making template setting layout dragable
 */

import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { ColumnPanelEventType } from '../../../widgets/column-panel/column-panel.model';
import { BriefConfig } from '../../../widgets/widgets.model';
import { SettingConfig, ActionType } from '../template-setting-dialog.model';
import { TemplateSettingDialogService } from '../template-setting-dialog.service';

@Component({
    selector: 'tam-template-setting-layout',
    templateUrl: './template-setting-layout.component.html',
    styleUrls: ['./template-setting-layout.component.scss']
})
export class TemplateSettingLayoutComponent implements OnInit, OnDestroy {
    @Input() config;
    briefConfig = new BriefConfig();
    sectionName: string;

    private _destroySubscriptions: Array<Subscription> = [];

    constructor(private _templateSettingService: TemplateSettingDialogService) { }

    ngOnInit() {
        this.clickSection('', this.config[0].sectionName, true);
        this._destroySubscriptions.push(
            this._templateSettingService.actionSubject$.subscribe(item => this._settingTemplateConfig(item)),
            this.briefConfig.feedbackSubject$.subscribe(item => {
                if (item.type === ColumnPanelEventType.SORT) {
                    this._templateSettingService.actionSubject$.next(new SettingConfig(ActionType.MOVE_SECTION, item.payload));
                }
            })
        );
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
        this._destroySubscriptions = [];
    }

    clickSection(event, name, isUserAddControl = false) {
        const layout = this.config;
        this.sectionName = name.toUpperCase();
        this._templateSettingService.actionSubject$.next(new SettingConfig(ActionType.CLICK_SECTION, '', this.sectionName));
        for (const item of layout) {
            if (item.sectionName === name.toUpperCase()) {
                item.isExpandSection = !item.isExpandSection;
                if (isUserAddControl) {
                    item.isExpandSection = true;
                }
            } else {
                if (item.isExpandSection) {
                    item.isExpandSection = false;
                }
            }
        }
    }

    private _settingTemplateConfig(item: SettingConfig) {
        switch (item.action) {
            case ActionType.ADD:
                this.clickSection('', item.location, true);
                break;
            case ActionType.RESET:
                this.clickSection('', item.location, true);
                break;
        }
    }
}
